import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  oneTimeSubscriptionBundleId: null,
  defaultDailySubButtonEnabled: true,
  showCustomSmsModal: false,
  phoneShortcutEnabled: false,
  homeScreenModalDisable: false,
  installPromptEvent: null,
  maximumDigitsPinLength: null,
  GameTypesEnums: {
    MUSIC: 'MUSIC',
    NO_CATEGORY: 'NO_CATEGORY',
    GEOGRAPHY: 'GEOGRAPHY',
    MOVIES: 'MOVIES',
    FOOD: 'FOOD',
    ARTS: 'ARTS',
    HISTORY: 'HISTORY',
    SPORTS: 'SPORTS',
    SCIENCE: 'SCIENCE',
    WORLD: 'WORLD',
    MATH: 'MATH',
    NATURE: 'NATURE',
    LANGUAGES: 'LANGUAGES',
    CHRISTMAS: 'CHRISTMAS',
    RAMADAN: 'RAMADAN',
    ISLAMIC: 'ISLAMIC',
    SUMMER: 'SUMMER',
    FOOTBALL: 'FOOTBALL',
    KNOW_YOUR_COUNTRY: 'KNOW_YOUR_COUNTRY',
  },
  GameModesEnums: {
    EASY: 'EASY',
    HARD: 'HARD',
    VERY_HARD: 'VERY_HARD',
  },
  activeModals: [],
  howItWinType: 0,
  hidePrizeSectionEnabledAtLeaderBoard: false,
  pushNotificationsPublicKey: '',
  inviteConfig: {},
  /**
   * Mapping for notifications
   * @property{string} text, equals the notificationCategoryDTO name
   * @property{string} value, equals the notificationCategoryDTO value
   * @property{string} notificationTitleTranslation, the translation for notification title (if applicable)
   * @property{string} notificationTextBeforeTranslation, the translation for notification description first part
   * @property{string} notificationTextAfterTranslation, the translation for notification description second part (if applicable)
   * @property{string} notificationButtonTranslation, the translation for notification 'check it' button
   * @property{string} showModal, the modal that will be shown on 'check it' button click
   * @property{boolean} dynamicText, if the notification description contains date (or other dynamic) info
   * WAG-65 jira ticket
   */
  notificationsNames: Object.freeze({
    ChangeUsernameOrPin: {
      text: 'Change Username or Pin',
      value: '',
      notificationTitleTranslation: 'home_notifications_change_username_or_pin_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_change_username_or_pin_button',
      showModal: '',
      dynamicText: false,
    },
    BonusPhasesDaily: {
      text: 'Bonus Phases Daily',
      value: '',
      notificationTitleTranslation: 'home_notification_bonus_phase_daily_bonus_title',
      notificationTextBeforeTranslation: '',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: '',
      dynamicText: false,
    },
    BonusRegistration: {
      text: 'Bonus Points',
      value: 'Registration',
      notificationTitleTranslation: 'home_modals_notifications_bonus_registration',
      notificationTextBeforeTranslation: 'notifications_bonus_registration_before',
      notificationTextAfterTranslation: 'notifications_bonus_registration_after',
      notificationButtonTranslation: '',
      showModal: '',
      dynamicText: false,
    },
    BundleDiscount: {
      text: 'Bundle Discount',
      value: 'Bundle Discount',
      notificationTitleTranslation: 'notifications_bundle_discount_title',
      notificationTextBeforeTranslation: 'notifications_bundle_discount_before',
      notificationTextAfterTranslation: 'notifications_bundle_discount_after',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: '',
      dynamicText: true,
    },
    BonusPointsPhase: {
      text: 'Bonus Points Phase',
      value: 'Bonus Points Phase',
      notificationTitleTranslation: 'notifications_bonus_points_phase_title',
      notificationTextBeforeTranslation: 'notifications_bonus_points_phase_before',
      notificationTextAfterTranslation: 'notifications_bonus_points_phase_after',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: '',
      dynamicText: true,
    },
    Achievement: {
      text: 'Achievement',
      value: 'Achievement',
      notificationTitleTranslation: 'home_notifications_achievement_title',
      notificationTextBeforeTranslation: 'notifications_achievement_text_before',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'NewAchievement',
      dynamicText: false,
    },
    SpinWheel: {
      text: 'Pending spinning wheel game',
      value: 'PendingSpinningWheelGame',
      notificationTitleTranslation: 'home_notification_spin_wheel_title',
      notificationTextBeforeTranslation: 'notifications_spin_wheel_text_before',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: 'home_notifications_check_it',
      showModal: 'SpinWheel',
      dynamicText: false,
    },
    InvitationRegistration: {
      text: 'Free Game',
      value: 'Referral',
      notificationTitleTranslation: 'notifications_invite_registration_title',
      notificationTextBeforeTranslation: 'notifications_invite_registration_before',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: '',
      showModal: '',
      dynamicText: false,
    },
    TopRanking: {
      text: 'Top Ranking',
      value: 'TopRanking',
      notificationTitleTranslation: 'notifications_invite_ranking_title',
      notificationTextBeforeTranslation: 'notifications_ranking_before',
      notificationTextAfterTranslation: '',
      notificationButtonTranslation: '',
      showModal: 'Ranking',
      dynamicText: false,
    },
  }),
  freeTrialGuaranteedPrize: null,
  freeTrialPoints: null,
  freeTrialPrice: null,
  freeTrialRedirectionUrl: null,
  freeTrialUserPrice: null,
  validTransitionForFreeGame: true,
  unauthorizedMsisdn: null,
  code: null,
  prizeType: {
    daily: 'DAILY_INSTANT_REWARD',
    weekly: 'WEEKLY_INSTANT_REWARD',
    monthly: 'MONTHLY_INSTANT_REWARD',
  },
  jackpotCountdownDay: 0,
  secForMatchedCards: 1000,
  minGamesToPlay: 0,
  timeRoundIntro: null,
  availableFBLanguagesForSDK: Object.freeze({
    EN: 'en_US',
    AR: 'ar_AR',
    FA: 'fa_IR',
    FR: 'fr_FR',
    PS: 'ps_AF',
  }),
  isBrandedProject: null,
  brandedProjectsBasedOnSkin: [],
  cpc: null,
  showMsisdnInProfilePage: false,
  hideChangePassword: false,
  hideLangSelection: false,
  timeWinnerIndication: null,
  hideLeaderboard: false,
  purchaseBundleFromUnsubUser: false,
  integrationHeader: '',
  simpleRegistration: '',
  showSelectOperatorModal: false,
  hasSingleOptIn: false,
  availableIntegrations: {
    MONDIA_PAY_DENMARK: {
      name: 'mondia_pay_denmark_he',
      info: [],
      transferDigitalParams: false,
      storeDigitalParams: false,
      affectsMultiOperator: false,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasAsync: true,
      showRegistrationModal: true,
      hasConfirmation: false,
      hasOptOutAsync: false,
      oneTimeSubscription: true,
    },
    OMANTEL_OMAN: {
      name: 'omantel_oman_he',
      info: [],
      transferDigitalParams: false,
      storeDigitalParams: false,
      affectsMultiOperator: false,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasAsync: true,
      showRegistrationModal: true,
      hasConfirmation: false,
      hasOptOutAsync: false,
      oneTimeSubscription: true,
    },
    KOREK_IRAQ: {
      name: 'koreq_iraq_he',
      transferDigitalParams: true,
      storeDigitalParams: false,
      affectsMultiOperator: false,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      addGraph: true,
    },
    ASIACELL_IRAQ: {
      name: 'asiacell_iraq_he',
      info: [],
      transferDigitalParams: false,
      affectsMultiOperator: true,
      storeDigitalParams: true,
      hasExternalRedirection: false,
      hasThirdPartyReSub: true,
      hidePage: false,
      hasConfirmation: false,
      addGraph: true,
      hasAsync: true,
      hasHeReSub: false,
    },
    CROSS_IRAQ: {
      name: 'cross_iraq_he',
      info: [],
      transferDigitalParams: false,
      affectsMultiOperator: true,
      storeDigitalParams: true,
      hasExternalRedirection: false,
      hasThirdPartyReSub: true,
      hidePage: false,
      hasConfirmation: false,
      addGraph: true,
      hasAsync: true,
      hasHeReSub: false,
    },
    KSA_MOBILY: {
      name: 'ksa_mobily_he',
      info: [{ key: 'operator', value: '' }, { key: 'msisdn', value: '' }, { key: 'lang', value: '' }],
      transferDigitalParams: false,
      affectsMultiOperator: false,
      storeDigitalParams: true,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      disableLogout: false,
      hideTerms: false,
      oneTimeSubscription: false,
      enabledStatusInSettingsPage: true,
      hideLangSelectionLoginArea: false,
      disableUpdateLangInCore: false,
      mapLang: [],
      hasAsync: true,
      hasHeReSub: true,
      resubOnForgot: false,
      unsubWithSms: true,
      addGraph: true,
    },
    ORANGE_EGYPT: {
      name: 'orange_egypt_he',
      info: [],
      transferDigitalParams: false,
      storeDigitalParams: false,
      affectsMultiOperator: false,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      addGraph: true,
    },
    VIVA_KUWAIT: {
      name: 'viva_kuwait_he',
      info: [{ key: 'lang', value: '' }],
      transferDigitalParams: true,
      storeDigitalParams: false,
      affectsMultiOperator: false,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      addGraph: true,
    },
    VODACOM: {
      name: 'vodacom_he',
      info: [{ key: 'packageId', value: '' }],
      transferDigitalParams: false,
      affectsMultiOperator: false,
      storeDigitalParams: false,
      hasExternalRedirection: true,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      addGraph: true,
    },
    ROSHAN_AFG: {
      name: 'roshan_afg',
      info: [{ key: 'operator', value: '' }, { key: 'msisdn', value: '' }, { key: 'lang', value: '' }],
      transferDigitalParams: false,
      affectsMultiOperator: false,
      storeDigitalParams: true,
      hasExternalRedirection: false,
      hasThirdPartyReSub: true,
      hidePage: false,
      hasConfirmation: false,
      addGraph: false,
    },
    DU_ETISALAT: {
      name: 'du_etisalat',
      info: [{ key: 'operator', value: '' }, { key: 'msisdn', value: '' }, { key: 'lang', value: '' }],
      transferDigitalParams: false,
      affectsMultiOperator: true,
      storeDigitalParams: true,
      hasExternalRedirection: false,
      hasThirdPartyReSub: true,
      hidePage: false,
      hasConfirmation: false,
      addGraph: true,
    },
    VIVA_BAHRAIN: {
      name: 'viva_bahrain_he',
      info: [],
      transferDigitalParams: false,
      affectsMultiOperator: false,
      storeDigitalParams: false,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: true,
      hasConfirmation: true,
      addGraph: true,
    },
    BATELCO_BAHRAIN: {
      name: 'batelco_bahrain_he',
      info: [],
      transferDigitalParams: false,
      affectsMultiOperator: false,
      storeDigitalParams: false,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      addGraph: true,
    },
    CONGO_MTN: {
      name: 'congo_mtn_he',
      info: [],
      transferDigitalParams: false,
      affectsMultiOperator: false,
      storeDigitalParams: true,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      disableLogout: false,
      hasAsync: false,
      hasOptOutAsync: false,
      showRegistrationModal: false,
    },
    IRAQ_ZAIN: {
      name: 'iraq_zain_he',
      info: [],
      transferDigitalParams: false,
      affectsMultiOperator: false,
      storeDigitalParams: true,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      disableLogout: false,
      hasAsync: true,
    },
    OOREDOO_OMAN_V2: {
      name: 'ooredoo_oman_v2_he',
      info: [],
      transferDigitalParams: false,
      affectsMultiOperator: false,
      storeDigitalParams: false,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      disableLogout: false,
      hideTerms: false,
      oneTimeSubscription: true,
      showRegistrationModal: false,
      enabledStatusInSettingsPage: false,
      hideLangSelectionLoginArea: false,
      disableUpdateLangInCore: false,
      mapLang: [],
      hasAsync: false,
      hasHeReSub: false,
      resubOnForgot: false,
      unsubWithSms: false,
    },
    MTN_RWA: {
      name: 'mtn_rwanda_he',
      info: [],
      transferDigitalParams: false,
      affectsMultiOperator: false,
      storeDigitalParams: true,
      hasExternalRedirection: false,
      hasThirdPartyReSub: false,
      hidePage: false,
      hasConfirmation: false,
      disableLogout: false,
      hasAsync: false,
      hasOptOutAsync: false,
      showRegistrationModal: false,
      hasLoadingOnReSub: true,
      hasLoadingOnOptOut: true,
    },
  },
  availableFlows: {
    DEFAULT: {
      propertyName: 'DEFAULT',
      blockedRoutes: [],
    },
    SIMPLE_WITH_WEB_REGISTRATION: {
      propertyName: 'SIMPLE_WITH_WEB_REGISTRATION',
      blockedRoutes: ['/forgotPassword2', '/forgotPassword3'],
    },
    SIMPLE_WITHOUT_WEB_REGISTRATION: {
      propertyName: 'SIMPLE_WITHOUT_WEB_REGISTRATION',
      blockedRoutes: ['/twostepregister1', '/forgotPassword2', '/forgotPassword3', '/twostepforgotPassword1'],
    },
  },
  mergedParam: '',
  hidePrizePage: false,
  purchaseViaSMS: null,
  fbAppId: '',
  versionInfo: {},
  roundTimeList: [],
  multiOperatorInfo: {
    multiOperatorEnabled: false,
    multiOperatorOrdinal: 0,
    multiOperatorDisplayNames: [],
    operatorPicked: '',
    multiOperatorKeys: [],
    multiOperatorDisplayedNamesInRegisterPage: [],
  },
  winnersShowMsisdn: false,
  duelSkin: 0,
  displayPrice: false,
  hideStore: false,
  smsAutomaticResponse: false,
  swipoGameThemes: '',
  swipoTimeForPreGameModals: 0,
  hideWinners: false,
  facebookFunctionality: false,
  lastRandomRound: 0,
  banner: '',
  userAvatar: '',
  fbReferral: '',
  connectionPoints: 0,
  reoptinOnestep: false,
  refUrl: '',
  correlationId: '',
  campaignId: '',
  publisherId: '',
  clickid: '',
  splashUrl: '',
  splashTimer: 0,
  profilePath: true,
  modalForHomePage: null,
  showOptOutPhase: false,
  modalForSettings: null,
  modalForStore: null,
  avatarGrouping: 0,
  storeItems: [],
  pinForBundles: false,
  subAndUnsubViaSMS: false,
  reoptinAndOptoutConfig: '',
  twoStepRegistration: false,
  freeTrialStripe: false,
  logoOnFooter: false,
  trackingId: '',
  facebookPixelId: '',
  vatBanner: false,
  soundsOn: true,
  hideJackpot: false,
  userDetails: {
    wonPrizes: [],
    displayAvatar: false,
    msisdn: '',
    level: 0,
    totalPointsEarned: 0,
    dailyPointsEarned: 0,
    weeklyPointsEarned: 0,
    monthlyPointsEarned: 0,
    gamesPlayed: 0,
    gamesWon: 0,
    answersGiven: 0,
    correctAnswersGiven: 0,
    availableGames: 0,
    freeGamesUntil: 0,
    language: '',
    gamesToNextLevel: 0,
    username: '',
    avatar: '',
    avatarGender: 'male',
    subscribed: '',
    facebookId: '',
    availableCoins: '',
    hasPhoneShortcut: '',
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/common/index.js